import Vue from 'vue'
import Router from 'vue-router'
import { getLS, removeLS, storeLS } from './utils/localStorage-utils'
import UserConst from './enums/user'
import Cookies from 'js-cookie'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [

        {
            // =============================================================================
            // MAIN LAYOUT ROUTES
            // =============================================================================
            path: '/',
            component: () =>
                import ('./layouts/main/Main.vue'),
            children: [
                // =============================================================================
                // Theme Routes
                // =============================================================================
                {
                    path: '/',
                    name: 'after-login',
                    component: () =>
                        import ('./views/AfterLogin.vue'),
                    meta: {
                        rule: 'user',
                        requiresAuth: true
                    }
                },
                {
                    path: '/dashboard',
                    name: 'dashboard',
                    component: () =>
                        import ('./views/Dashboard.vue'),
                    meta: {
                        pageTitle: 'ダッシュボード',
                        rule: 'user',
                        requiresAuth: true
                    }
                },
                {
                    path: '/system-notifications',
                    name: 'notification-for-systems',
                    component: () =>
                        import ('./views/NotificationsForSystem.vue'),
                    meta: {
                        pageTitle: 'お知らせ一覧',
                        rule: 'user',
                        requiresAuth: true
                    }
                },
                {
                    path: '/box/:email/:inquiry_id/reply',
                    name: 'reply-mail',
                    component: () =>
                        import ('./views/SendMail.vue'),
                    meta: {
                        pageTitle: '返信メール送信',
                        rule: 'user',
                        requiresAuth: true,
                        isHideLeftMenu: true,
                        isShowIConContact: true
                    }
                },
                {
                    path: '/box/:email/:inquiry_id/forward-mail',
                    name: 'reply-mail',
                    component: () =>
                        import ('./views/SendMail.vue'),
                    meta: {
                        pageTitle: '転送メール返信',
                        rule: 'user',
                        requiresAuth: true,
                        isHideLeftMenu: true,
                        isShowIConContact: true
                    }
                },
                {
                    path: '/box/:email/:inquiry_id/reply/:send_mail_id',
                    name: 'view-mail-reply',
                    component: () =>
                        import ('./views/SendMail.vue'),
                    meta: {
                        pageTitle: '返信メール詳細',
                        rule: 'user',
                        requiresAuth: true,
                        isHideLeftMenu: true
                    }
                },
                {
                    path: '/box/:email',
                    name: 'box',
                    component: () =>
                        import ('./views/MailBox.vue'),
                    meta: {
                        pageTitle: 'お問い合わせ一覧',
                        rule: 'user',
                        requiresAuth: true
                    }
                },
                {
                    path: '/spam/:email',
                    name: 'spam',
                    component: () =>
                        import ('./views/MailBox.vue'),
                    meta: {
                        pageTitle: '迷惑メール一覧',
                        rule: 'user',
                        requiresAuth: true
                    }
                },
                {
                    path: '/box/:email/:inquiry_id',
                    name: 'receive-mail-detail',
                    component: () =>
                        import ('./views/ReceiveMailDetail.vue'),
                    meta: {
                        pageTitle: 'お問い合わせ詳細',
                        rule: 'user',
                        requiresAuth: true,
                        isHideLeftMenu: true
                    }
                },
                {
                    path: 'change-password',
                    name: 'change-password',
                    component: () =>
                        import ('./views/ChangePassword'),
                    meta: {
                        pageTitle: 'パスワード更新',
                        rule: 'user',
                        requiresAuth: true
                    }
                },
                {
                    path: '/sent/:email/create-mail',
                    name: 'create-mail',
                    component: () =>
                        import ('./views/SendMail.vue'),
                    meta: {
                        pageTitle: '新規メール作成',
                        rule: 'user',
                        requiresAuth: true,
                        isHideLeftMenu: true,
                        isShowIConContact: true
                    }
                },
                {
                    path: '/sent/:email/create-multiple-mail',
                    name: 'create-mail-multiple',
                    component: () =>
                        import ('./views/Broadcast.vue'),
                    meta: {
                        pageTitle: '一斉送信',
                        rule: 'user',
                        requiresAuth: true,
                        isShowIConContact: true
                    }
                },
                {
                    path: '/trash/:email',
                    name: 'trash',
                    component: () =>
                        import ('./views/MailTrash.vue'),
                    meta: {
                        pageTitle: 'ゴミ箱',
                        rule: 'user',
                        requiresAuth: true
                    }
                },
                {
                    path: '/trash/:email/:inquiry_id',
                    name: 'trash-mail-detail',
                    component: () =>
                        import ('./views/TrashMailDetail.vue'),
                    meta: {
                        pageTitle: 'お問い合わせ詳細',
                        rule: 'user',
                        requiresAuth: true,
                        isHideLeftMenu: true
                    }
                },
                {
                    path: '/sent/:email/:send_mail_id',
                    name: 'view-mail-sent',
                    component: () =>
                        import ('./views/SendMail.vue'),
                    meta: {
                        pageTitle: 'メール送信詳細',
                        rule: 'user',
                        requiresAuth: true,
                        isHideLeftMenu: true
                    }
                },
                {
                    path: '/sent/:email/:send_mail_id/draft',
                    name: 'view-mail-sent',
                    component: () =>
                        import ('./views/SendMail.vue'),
                    meta: {
                        pageTitle: '下書き',
                        rule: 'user',
                        requiresAuth: true
                    }
                },
                {
                    path: 'sent/:email',
                    name: 'mail-sent',
                    component: () =>
                        import ('./views/MailSent.vue'),
                    meta: {
                        pageTitle: 'メール送信一覧　',
                        rule: 'user',
                        requiresAuth: true
                    }
                },
                //Mail Draft
                {
                    path: 'draft/:email',
                    name: 'mail-draft',
                    component: () =>
                        import ('./views/MailDraft.vue'),
                    meta: {
                        pageTitle: '下書き一覧',
                        rule: 'user',
                        requiresAuth: true
                    }
                },
                {
                    path: '/draft/:email/:send_mail_id',
                    name: 'view-mail-draft',
                    component: () =>
                        import ('./views/SendMail.vue'),
                    meta: {
                        pageTitle: '返信メール作成',
                        rule: 'user',
                        requiresAuth: true,
                        isHideLeftMenu: true,
                        isShowIConContact: true
                    }
                },
                {
                    path: '/draft/:email/:send_mail_id/forward-mail',
                    name: 'view-mail-draft',
                    component: () =>
                        import ('./views/SendMail.vue'),
                    meta: {
                        pageTitle: '転送メール返信',
                        rule: 'user',
                        requiresAuth: true,
                        isHideLeftMenu: true,
                        isShowIConContact: true
                    }
                },
                // {
                //   path: 'box/:email/folder/:folder',
                //   name: 'mail-sent',
                //   component: () =>
                //       import ('./views/MailBox.vue'),
                //   meta: {
                //       pageTitle: 'メール送信一覧　',
                //       rule: 'user',
                //       requiresAuth: true
                //   }
                // },
                //
                {
                    path: 'chat',
                    name: 'mail-chat',
                    component: () =>
                      import ('./views/chat/Chat'),
                    meta: {
                        pageTitle: 'チャット',
                        rule: 'user',
                        requiresAuth: true,
                        requiresChatAuth: true
                    }
                },
                {
                    path: 'chat/list/:id',
                    name: 'mail-chat-detail',
                    component: () =>
                        import ('./views/chat/ChatDetail'),
                    meta: {
                        pageTitle: 'チャット',
                        rule: 'user',
                        requiresAuth: true
                    }
                },
                {
                    path: 'box/:email/folder/*',
                    name: 'mail-sent',
                    component: () =>
                      import ('./views/MailBox.vue'),
                    meta: {
                        pageTitle: '受信一覧',
                        rule: 'user',
                        requiresAuth: true
                    }
                },
                /* , {
                    path: '/inbox',
                    redirect: '/apps/email/inbox',
                    name: 'inbox',
                    meta: {
                      rule: 'user',
                      requiresAuth: true
                    }
                  },
                  {
                    path: '/apps/email/:filter',
                    component: () => import('./views/apps/email/Email.vue'),
                    meta: {
                      rule: 'user',
                      parent: 'email',
                      no_scroll: true,
                      requiresAuth: true
                    }
                  },
                  }*/
                  {
                    path: 'sent-failed/:email/',
                    name: 'mail-sent-failed',
                    component: () =>
                      import ('./views/MailSentFailed.vue'),
                    meta: {
                        pageTitle: 'メール送信失敗一覧',
                        rule: 'user',
                        requiresAuth: true,
                        isShowIConContact: true
                    }
                },
                  {
                    path: 'telephone-box/:telephoneId',
                    name: 'telephone-box',
                    component: () =>
                      import ('./views/telephone/List.vue'),
                    meta: {
                        pageTitle: '電話一覧',
                        rule: 'user',
                        requiresAuth: true
                    }
                },
            ]
        },
        {
            // =============================================================================
            // MAIN LAYOUT ROUTES
            // =============================================================================
            path: '/admin',
            redirect: '/admin/dashboard',
            component: () =>
                import ('./layouts/main/AdminMain.vue'),
            children: [
                // =============================================================================
                // Theme Routes
                // =============================================================================
                {
                    path: '/admin/dashboard',
                    name: 'admin-dashboard',
                    component: () =>
                        import ('./views/Dashboard.vue'),
                    meta: {
                        pageTitle: 'ダッシュボード',
                        rule: 'admin',
                        requiresAuth: true
                    }
                },
                {
                    path: '/admin/admin-management',
                    name: 'admin-management',
                    component: () =>
                        import ('./views/admin/admin-management/Admin.vue'),
                    meta: {
                        pageTitle: '管理者',
                        rule: 'admin'
                    }
                },
                {
                    path: '/admin/user',
                    name: 'admin-user',
                    component: () =>
                        import ('./views/admin/user/User.vue'),
                    meta: {
                        pageTitle: '利用者設定',
                        rule: 'admin',
                        requiresAuth: true
                    }
                },
                {
                    path: '/admin/customer',
                    name: 'admin-customer',
                    component: () =>
                        import ('./views/admin/customers/Customers.vue'),
                    meta: {
                        pageTitle: '顧客管理',
                        rule: 'admin',
                        requiresAuth: true
                    }
                },
                {
                    path: '/admin/telephone-server',
                    name: 'admin-telephone-server',
                    component: () =>
                        import ('./views/admin/telephone-server/TelephoneServer.vue'),
                    meta: {
                        pageTitle: '電話管理',
                        rule: 'admin',
                        requiresAuth: true
                    }
                },
                {
                    path: '/admin/mail-server',
                    name: 'admin-server',
                    component: () =>
                        import ('./views/admin/mail-server/MailServer.vue'),
                    meta: {
                        pageTitle: 'メールサーバ',
                        rule: 'admin',
                        requiresAuth: true
                    }
                },
                {
                  path: '/admin/settings',
                  name: 'admin-settings',
                  component: () => import('./views/admin/settings/Settings.vue'),
                  meta: {
                    pageTitle: '制限設定',
                    rule: 'admin',
                    requiresAuth: true
                  }
                },
                {
                    path: '/admin/kinds',
                    name: 'admin-kinds',
                    component: () => import('./views/admin/kinds/Kinds.vue'),
                    meta: {
                        pageTitle: '種別管理',
                        rule: 'admin',
                        requiresAuth: true
                    }
                },
                {
                    path: '/admin/status-management',
                    name: 'admin-status-management',
                    component: () => import('./views/admin/status-management/Status.vue'),
                    meta: {
                        pageTitle: '状態管理',
                        rule: 'admin',
                        requiresAuth: true
                    }
                },
                {
                    path: '/admin/subscription',
                    name: 'admin-subscription',
                    component: () => import('./views/admin/subsciption/Subscription'),
                    meta: {
                        pageTitle: 'サブスクライブ',
                        rule: 'admin',
                        requiresAuth: true
                    }
                },
                {
                    path: '/admin/mail-error',
                    name: 'admin-mail-error',
                    component: () => import('./views/admin/mail-error/MailError.vue'),
                    meta: {
                        pageTitle: 'エラー一覧',
                        rule: 'admin',
                        requiresAuth: true
                    }
                }
            ]
        },
        {
            // =============================================================================
            // MAIN LAYOUT ROUTES
            // =============================================================================
            path: '/shachi',
            redirect: '/shachi/dashboard',
            component: () =>
                import ('./layouts/main/AdminMain.vue'),
            children: [
                // =============================================================================
                // Theme Routes
                // =============================================================================
                {
                    path: '/shachi/dashboard',
                    name: 'shachi-dashboard',
                    component: () =>
                        import ('./views/ShachiDashboard.vue'),
                    meta: {
                        pageTitle: 'お問い合わせ管理・利用状況',
                        rule: 'sys_admin',
                        requiresAuth: true
                    }
                },
                {
                    path: '/shachi/mail-send-resume',
                    name: 'mail-send-resume',
                    component: () => import('./views/admin/mail-send-resume/MailSendResume.vue'),
                    meta: {
                        pageTitle: '送信状況',
                        rule: 'sys_admin',
                        requiresAuth: true
                    }
                },
                {
                    path: '/shachi/company',
                    name: 'company-settings',
                    component: () => import('./views/admin/company/Company.vue'),
                    meta: {
                        pageTitle: '企業設定',
                        rule: 'sys_admin',
                        requiresAuth: true
                    }
                },
                {
                    path: '/shachi/settings',
                    name: 'shachi-settings',
                    component: () => import('./views/admin/settings/Settings.vue'),
                    meta: {
                        pageTitle: '設定',
                        rule: 'sys_admin',
                        requiresAuth: true
                    }
                },
            ]
        },
        // =============================================================================
        // FULL PAGE LAYOUTS
        // =============================================================================
        {
            path: '',
            component: () =>
                import ('@/layouts/full-page/FullPage.vue'),
            children: [
                // =============================================================================
                // PAGES
                // =============================================================================
                {
                    path: '/login',
                    name: 'login',
                    component: () =>
                        import ('@/views/pages/Login.vue'),
                    meta: {
                        rule: 'user'
                    }
                },
                {
                    path: 'error-404',
                    name: 'error-404',
                    component: () =>
                        import ('@/views/pages/Error404.vue'),
                    meta: {
                        rule: 'user'
                    }
                },
                {
                    path: 'forgot-password',
                    name: 'forgot-password',
                    component: () =>
                        import ('@/views/pages/password/ForgotPassword.vue'),
                    meta: {
                        rule: 'user'
                    }
                },
                {
                    path: 'forgot-password-success',
                    name: 'forgot-password-success',
                    component: () =>
                        import ('@/views/pages/password/ForgotPasswordSuccess.vue'),
                    meta: {
                        rule: 'user'
                    }
                },
                {
                    path: 'password-init',
                    name: 'password-init',
                    component: () =>
                        import ('@/views/pages/password/InitPassword.vue'),
                    meta: {
                        rule: 'user'
                    }
                },
                {
                  path: '/subscription-register',
                  name: 'subscription-register',
                  component: () => import('@/views/pages/subscription/RegisterSubscription.vue'),
                  meta: {
                    rule: 'user'
                  }
                },
                {
                  path: '/subscription-confirm',
                  name: 'subscription-confirm',
                  component: () => import('@/views/pages/subscription/ConfirmSubscription.vue'),
                  meta: {
                    rule: 'user'
                  }
                }
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*/login',
            redirect: 'login'
        },
        {
            path: '*',
            redirect: 'error-404'
        }
    ]
})

router.beforeEach(async(to, from, next) => {
    //Handle post message
    await new Promise(resolve => setTimeout(resolve,200));
    const handlePostMessage = async event => {
      try {
        let data = JSON.parse(event.data);
        if (data.from){
          let keys = ['id', 'remember_me', 'password', 'from'];
          let isValid = true;
          Object.keys(data).map(key => isValid = keys.indexOf(key) != -1 && isValid);
          if (isValid) {
            storeLS('from', data.from);
            storeLS('postMessage', JSON.stringify(data));
          };
        }
      } catch (e){
      }
    }
    window.addEventListener("message", e => handlePostMessage(e));
    if (to.name == 'view-mail-draft' && to.fullPath.includes("back=true")) {
        to.meta.pageTitle = '下書き'
    }
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (to.path == '/') {
            let redirect = to.query.redirect;
            var token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : Cookies.get('rememberLogin');
            var user = getLS('userInfo');
            if (token && user) {
                user = JSON.parse(user);
                if (user.id) {
                    if (redirect){
                        location.href = redirect
                    }else if (user.auth_flg == UserConst.AUTH_FLG_ADMIN) {
                        next('/admin')
                        return;
                    } else if (user.auth_flg == UserConst.AUTH_SYS_ADMIN) {
                        next('/shachi/dashboard')
                        return;
                    } else {
                        next();
                    }
                }
            }
        }
        if (getLS('postMessage') && getLS('from')) {
          next();
          return;
        } else {
          // Action getLS() check in next step (current code not set key 'user' in local storage)
          var token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : Cookies.get('rememberLogin');
          var user = getLS('userInfo');
          if (token && user) {
              user = JSON.parse(user);
              // if (user.id) {
              //     if (to.matched.some(record => record.meta.requiresChatAuth) && !user.enable_chat){
              //         // check if the user can to access chat function
              //         next('404')
              //         return;
              //     }else{
              //         next();
              //         return;
              //     }
              // }
            next();
            return;
          }

          // Todo: check exist key or force remove
          sessionStorage.removeItem('token');
          removeLS('userInfo');
          removeLS('postMessage');
          removeLS('from');
          Cookies.remove('rememberLogin')
          localStorage.removeItem('expires_time');
          // const return_url = localStorage.getItem('return_url');

          //  redirect to login if unauthen
          next('login')
            // this.$ls.set(`logout`, Date.now())
        }
    } else {
        if (to.path == '/login') {
            let redirect = to.query.redirect;
            var token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : Cookies.get('rememberLogin');
            var user = getLS('userInfo');
            if (token && user) {
                user = JSON.parse(user);
                if (user.id) {
                    if (redirect){
                        location.href = redirect
                    }else if (user.auth_flg == UserConst.AUTH_FLG_ADMIN) {
                        next('/admin')
                        return;
                    } else if (user.auth_flg == UserConst.AUTH_SYS_ADMIN) {
                        next('/shachi/dashboard')
                        return;
                    } else {
                        next('/')
                        return;
                    }
                }
            }
        }
        next();
    }

});

router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = 'none'
    }
})

export default router